import React from 'react';
import { useMediaQuery } from 'react-responsive';
import NavBar from './Navbar/NavBar';
import heroImg from '../images/logoRM.webp';

const Hero = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <section className="hero relative overflow-hidden" id="hero">
      <NavBar />

      <div className="mx-auto flex min-h-screen max-w-7xl items-center px-4 pb-16 pt-32 md:px-6 md:pb-24 md:pt-36">
        <div className="grid w-full items-center gap-14 lg:grid-cols-[1.1fr_0.9fr]">
          <div data-aos="fade-up" data-aos-delay="100">
            <div className="mb-6 inline-flex items-center rounded-full border border-white/80 bg-white/75 px-4 py-2 text-xs font-semibold uppercase tracking-[0.32em] text-stone-700 shadow-sm backdrop-blur">
              Open daily in Kathu, Phuket
            </div>

            <h1 className="font-cyclin text-4xl font-bold leading-[0.98] text-slate-950 md:max-w-4xl md:text-6xl">
              Traditional Thai Massage in a calm, authentic setting.
            </h1>

            <p className="mt-7 max-w-2xl text-base leading-8 text-stone-700 md:text-lg">
              Professional Thai massage, oil massage, foot massage and deep
              tissue treatments with direct booking on WhatsApp, Line or
              Telegram.
            </p>

            <div className="mt-9 flex flex-col gap-4 sm:flex-row">
              <a
                href="https://wa.me/+66641831185"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-stone-900 px-7 py-4 font-cyclin text-lg font-bold text-white shadow-lg shadow-stone-900/15 transition hover:-translate-y-0.5 hover:bg-stone-800"
              >
                Book on WhatsApp
              </a>
              <a
                href="https://www.google.com/maps/place/Amonthanat+Massage/@7.9029261,98.3465686,15.83z/data=!4m6!3m5!1s0x305031af2ee373f5:0xb44d9e232635a261!8m2!3d7.89823!4d98.355965!16s%2Fg%2F11kr5xp2b2?entry=ttu"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center rounded-full border border-stone-300/80 bg-white/80 px-7 py-4 text-lg font-semibold text-stone-900 shadow-sm backdrop-blur transition hover:-translate-y-0.5 hover:bg-white"
              >
                Get Directions
              </a>
            </div>

            <div className="mt-9 flex flex-wrap gap-x-6 gap-y-3 text-sm font-medium text-stone-600">
              <span>9:00 AM to 9:00 PM</span>
              <span>11 massage options</span>
              <span>+66 64 183 1185</span>
              <span>Google reviews available</span>
            </div>
          </div>

          <div
            className="flex justify-center lg:justify-end"
            data-aos="zoom-in"
            data-aos-delay="250"
          >
            <div className="hero-card relative w-full max-w-md overflow-hidden rounded-[2.2rem] border border-white/80 bg-white/78 p-8 shadow-2xl shadow-stone-900/10 backdrop-blur">
              <div className="absolute -right-8 top-8 h-28 w-28 rounded-full bg-amber-100/60 blur-2xl" />
              <div className="absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-stone-300 to-transparent" />
              <img
                alt="Amonthanat Massage logo"
                className={`mx-auto object-contain ${
                  isMobile ? 'h-64 w-64' : 'h-80 w-80'
                }`}
                src={heroImg}
              />
              <div className="mt-6 text-center">
                <p className="font-cyclin text-3xl font-bold text-slate-950">
                  Amonthanat Massage
                </p>
                <p className="mt-3 text-sm uppercase tracking-[0.34em] text-stone-500">
                  Traditional care. Direct contact. Easy booking.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
